import { getSelfServiceData, selectEmployeeNo } from "@/Redux/Ducks/homeSlice";
import { toggleLoader } from "@/Redux/Ducks/loaderSlice";
import { setGlobalMessage } from "@/Redux/Ducks/messageSlice";
import { IUserForgotPassword, IUserLogin, IUserResetPassword, setLoginBasicData, setUserObject } from "@/Redux/Ducks/userSlice";
import { setUserWorkspace } from "@/Redux/Ducks/workspaceSlice";
import { requestForgotPassword, requestGetUserSpecificDetail, requestLoginBasicData, requestResetPassword, requestUserLogin, requestUserLogout } from "@/Redux/Sagas/Requests/user";
import { openAlert } from "@/UI/BaseComponents/Alert";
import { getCompanyDetails, getTokens, setCompanyDetails, setTokens } from "@/Utils/auth";
import { l_storage, s_storage } from "@/Utils/storage";
import { PayloadAction } from "@reduxjs/toolkit";
import { push } from "connected-react-router";
import { call, put } from "redux-saga/effects";

export function* handleLoginUser({ payload }: PayloadAction<IUserLogin>): any {
  try {

    yield put(toggleLoader(true));

    const response = yield requestUserLogin({ password: payload.password, clientno: payload.clientno, username: payload.username, languageno: payload.languageno });
    const data = response;

    yield put(setUserObject({ user: data.UserInfo, defaultPage: data.UserInfo.defaultPage, languageno: payload.languageno }));
    setCompanyDetails({ timezone: data.UserInfo.companytimezone, selectedLegalEntity: data.UserInfo.defaultlegalentityno, selectedLang: payload.languageno });

    setTokens({ RefreshToken: data.RefreshToken, AccessToken: data.AccessToken });

    const redirectTo = payload.redirectUrl || data.UserInfo.defaultPage;

    yield put(push(redirectTo));

  } catch (error: any) {
    yield put(setGlobalMessage({ error }));
  }
  finally {
    yield put(toggleLoader(false));
  }
}

export function* handleForgotPassword({ payload }: PayloadAction<IUserForgotPassword>): any {
  try {

    yield put(toggleLoader(true));

    yield requestForgotPassword(payload.email, payload.clientno);

    openAlert({ icon: "info", title: "Password Reset Request Sent", html: "A password reset message was sent to your email address. Please click the link in that message to reset your password. <br /><br /> <b>This link will expire in 10 minutes</b>" })
  } catch (error: any) {
    yield put(setGlobalMessage({ error }));
  }
  finally {
    yield put(toggleLoader(false));
  }
}

export function* handleResetPassword({ payload }: PayloadAction<IUserResetPassword>): any {
  try {

    yield put(toggleLoader(true));

    yield requestResetPassword(payload.email, payload.token, payload.password);

    openAlert({ icon: "success", title: "Password Successfully Reset", text: "Your password has been succesfully reset. Now you can login with the new password." })

    yield put(push("/"));

  } catch (error: any) {
    yield put(setGlobalMessage({ error }));
  }
  finally {
    yield put(toggleLoader(false));
  }
}

export function* handleGetUserSpecificDetail(): any {
  try {

    yield put(toggleLoader(true));

    const response = yield requestGetUserSpecificDetail();
    const data = response;

    let companySessionInfo = getCompanyDetails();

    const defaultLegalEntity = data.UserLegalEntity.filter((x: any) => x.isdefault)[0].legalentityno;

    if (!data.UserLegalEntity.filter((x: any) => x.legalentityno == companySessionInfo.selectedLegalEntity).length)
      companySessionInfo = {
        selectedLang: "",
        selectedLegalEntity: "",
        timezone: ""
      };

    const selectedLegalEntity = companySessionInfo.selectedLegalEntity || defaultLegalEntity;
    const selectedLanguage = companySessionInfo.selectedLang || data.languageno;

    const user = data.user[0];
    const userFavorites = data.userFavorites;
    const userWorkspace = data.userWorkspace;

    delete data.userFavorites;
    delete data.userWorkspace;

    if (data.CompanyLedgerInfo.length)
      data.CompanyLedgerInfo = data.CompanyLedgerInfo[0];
    else
      delete data.CompanyLedgerInfo;


    yield put(setUserObject({ ...data, user, authToken: getTokens().AccessToken, selectedLegalEntity, userFavorites }));
    yield put(setUserWorkspace(userWorkspace));
    yield put(selectEmployeeNo(user.employeeno));
    yield put(getSelfServiceData());

    setCompanyDetails({ timezone: data.companytimezone, selectedLegalEntity, selectedLang: selectedLanguage });

  } catch (error: any) {
    yield put(setGlobalMessage({ error }));
    yield put(push("/"));
  }
  finally {
    yield put(toggleLoader(false));
  }
}

export function* handleLogoutUser(): any {
  try {
    yield put(toggleLoader(true));

    s_storage.clear();
    l_storage.clear();
    yield put(push("/login"));

    yield call(requestUserLogout);

  } catch (error: any) {
    yield put(setGlobalMessage({ error }));
  }
  finally {
    yield put(toggleLoader(false));
  }
}

export function* handleGetLoginBasicData(): any {
  try {
    yield put(toggleLoader(true));

    const response = yield requestLoginBasicData();

    yield put(setLoginBasicData(response));


  } catch (error: any) {
    yield put(setGlobalMessage({ error }));
  }
  finally {
    yield put(toggleLoader(false));

  }
}
